/**
 * @fileoverview GET handler for the "/offerfit/:app_group_id/get_primary_kpi" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { offerfitAppGroupIdGetPrimaryKpi } from "./constants";
import type { OfferfitAppGroupIdGetPrimaryKpiResult, OfferfitAppGroupIdGetPrimaryKpiParams } from "./types";
import { isOfferfitAppGroupIdGetPrimaryKpiResult } from "./validators";

export const getOfferfitAppGroupIdGetPrimaryKpi = reactQueryFetcherAdapter(
  offerfitAppGroupIdGetPrimaryKpi,
  (
    signal: AbortSignal,
    { appGroupId, client, pipeline, usecase }: OfferfitAppGroupIdGetPrimaryKpiParams
  ): Promise<OfferfitAppGroupIdGetPrimaryKpiResult> => {
    return fetch(
      `/offerfit/${appGroupId}/get_primary_kpi`,
      "GET",
      { client, pipeline, usecase },
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  },
  isOfferfitAppGroupIdGetPrimaryKpiResult
);
